export * from "./propias.types";
export * from "./transferencias.types";
export * from "./quickFilter.types";
